var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._g(_vm._b({attrs:{"single-line":"","item-value":"id","item-text":"name","prepend-inner-icon":"mdi-home","value":_vm.value,"items":_vm.apartments,"loading":_vm.loading}},'v-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }